import type { CSSProperties, ReactNode } from "react";
import { formatMoney, type CurrencyOpts } from "../format";

/** Formatted text that may start with a currency ("MMK 105,210"): the code becomes the small label, anything else passes through. */
export function figure(value: ReactNode): ReactNode {
  if (typeof value !== "string") return value;
  const m = /^([A-Z]{3}) (-?[\d.,]+.*)$/.exec(value);
  return m ? (
    <>
      <span className="ccy">{m[1]}</span>
      {m[2]}
    </>
  ) : (
    value
  );
}

/** A big money figure (22px and up): the currency small in the text face, the amount in mono. Smaller amounts use formatMoney. */
export function Money({ amount, opts, className, style }: { amount: number | null | undefined; opts?: CurrencyOpts; className?: string; style?: CSSProperties }) {
  const code = opts?.currencyCode ?? "MMK";
  const text = formatMoney(amount, opts);
  return (
    <span className={className ? `num ${className}` : "num"} style={style}>
      <span className="ccy">{code}</span>
      {text.slice(code.length + 1)}
    </span>
  );
}
